import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useCoefficientData } from "hooks/configs/relance/useCoefficientData";
import { useCoefficientForm } from "hooks/configs/relance/useCoefficientForm";
import { PermissionGuard } from "components/configs/relance/PermissionGuard";
import { PageHeader } from "components/configs/relance/PageHeader";
import { CoefficientInput } from "components/configs/relance/CoefficientInput";
import { LoadingSpinner } from "components/configs/relance/LoadingSpinner";
import { ErrorMessage } from "components/configs/relance/ErrorMessage";
import InputRequire from "views/components/InputRequire";

const ConfigCoefficient = (props) => {
  const { t, ready } = useTranslation();

  const { data, isLoading, error } = useCoefficientData();
  const {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
  } = useCoefficientForm(data);

  // Mettre à jour "coefs" et "delays"
  const onChangeCoef = (newCoefficients) => {
    updateField("coefs", newCoefficients);
  };

  const onChangeDelai = (newDelais) => {
    updateField("delays", newDelais);
  };

  const onChangeLimit = (newLimit) => {
    updateField("limit", newLimit);
  }


  return (
    <PermissionGuard userPermissions={props.userPermissions} ready={ready}>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        id="kt_content"
      >
        <PageHeader t={t} />

        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="row">
            <div className="col">
              <div className="kt-portlet">
                <div className="kt-portlet__head">
                  <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                      {t("Configuration Coefficient et Délai")}
                    </h3>
                  </div>
                </div>

                <form method="POST" className="kt-form" onSubmit={handleSubmit}>
                  <div className="kt-portlet__body">
                    {error && <ErrorMessage error={error} t={t} />}


                    {isLoading ? (
                      <LoadingSpinner t={t} />
                    ) : (
                      <div className="row">
                        <div className="d-flex align-items-center justify-content-between col-12">
                          <label className="font-weight-bold col-lg-3">
                            {t("Limite du régulateur")} <InputRequire />
                            <i 
                              className="fa fa-info-circle ml-2" 
                              data-toggle="tooltip" 
                              data-placement="bottom"
                              title={t("Limite du régulateur")}
                            ></i>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.limit.length ? "is-invalid" : ""}`}
                            placeholder={t("Veuillez entrer la limite du régulateur")}
                            value={formData.limit}
                            onChange={(e) => onChangeLimit(e.target.value)}
                            style={{ height: 45 }}
                          />
                        </div>
                        <div className="col-12 my-3">
                          <div className="kt-separator kt-separator--dashed"></div>
                        </div>

                        <div className="col-md-6 border-right">
                          {/* SECTION COEFFICIENT */}
                          <CoefficientInput
                            label="Coefficients de relance avant échéance"
                            placeholder="Veuillez entrer le Coefficient"
                            values={formData.coefs || [""]}
                            onChange={onChangeCoef}
                            errors={errors.coefs}
                            t={t}
                          />
                        </div>

                        <div className="col-12 my-3 d-md-none">
                          <div className="kt-separator kt-separator--dashed"></div>
                        </div>
                        <div className="col-md-6 border-left">
                          {/* SECTION DÉLAI */}
                          <CoefficientInput
                            label="Délais de notification après échéance"
                            placeholder="Veuillez entrer le délai"
                            values={formData.delays || [""]}
                            onChange={onChangeDelai}
                            errors={errors.delays}
                            t={t}
                          />
                        </div>
                      </div>
                    )}
                  </div>
 
                  {/* PIED DU FORMULAIRE : BOUTON ENREGISTRER EN BAS À DROITE */}
                  <div className="kt-portlet__foot">
                    <div className="kt-form__actions d-flex justify-content-end">
                      <button
                        type="submit"
                        className={`btn btn-primary ${
                          isSubmitting
                            ? "kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light"
                            : ""
                        }`}
                        disabled={isSubmitting || isLoading}
                      >
                        {t("Enregistrer")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PermissionGuard>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(ConfigCoefficient);